import { apiClient, getBaseUrl, getIdToken } from ".";

export interface ProjectSecurityPolicy {
    projectId: string;
    mode: "optional" | "mfa_required";
    version: number;
    updatedBy?: string;
    updatedAt?: string;
}

export interface ProjectSecurityPolicyResponse {
    policy: ProjectSecurityPolicy;
    etag?: string;
}

async function request<T>(method: "get" | "put", projectId: string, data?: unknown, etag?: string) {
    const idToken = getIdToken();
    const response = await apiClient.request({
        method,
        url: `${getBaseUrl()}/ms-project/projects/${projectId}/security-policy`,
        data,
        headers: {
            ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
            ...(etag ? { "If-Match": etag } : {})
        }
    });
    return { policy: response.data, etag: response.headers.etag } as T;
}

// Kept outside the generated project SDK until the new policy endpoint lands there.
export const projectSecurityApi = {
    get: (projectId: string) => request<ProjectSecurityPolicyResponse>("get", projectId),
    update: (projectId: string, mode: ProjectSecurityPolicy["mode"], etag: string) =>
        request<ProjectSecurityPolicyResponse>("put", projectId, { mode }, etag)
};
